/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { DataTable, List, Paragraph, useTheme } from "react-native-paper";
import { spacing } from "@styles/spacing";
import { useMobileMediaQuery } from "@media-query";
import { Block } from "@block";
import { CARDITEM } from "../../../services/services-model.type";
import { FlatListItemCard } from "./card-source.modal";

interface ItemModalProps {
  item: FlatListItemCard;
  index: number;
  templateType?: string;
  onClick?: Function;
}

interface InfoItemData {
  title: string;
  label: string;
  value: string;
  description: string;
}

const ItemCardModal = (props: ItemModalProps) => {
  const { item, index, onClick } = props;
  const { colors, fonts } = useTheme();
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslation();

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        titleModal: {
          color: colors.accent,
        },
        styleDescription: {
          color: colors.placeholder,
          fontStyle: "italic",
        },
      }),
    [colors.accent, colors.placeholder],
  );

  const onPressItem = () => {
    if (onClick) onClick(item);
  };

  const getInfo = (): InfoItemData => {
    const cardItem: CARDITEM = item.data || {};
    return {
      title: cardItem.cardNum || "",
      label: item.value?.length ? t("ACC_SO_DU_KHA_DUNG") : "",
      value: item.value || "",
      description: cardItem?.embossName || "",
    };
  };

  const TitleItem = (info: InfoItemData) => (
    <DataTable style={{ paddingRight: spacing.small }}>
      <DataTable.Header style={{ flex: 1, paddingHorizontal: 0, paddingVertical: 0, borderWidth: 0, borderBottomWidth: 0 }}>
        <DataTable.Title style={{ flex: 1, paddingVertical: 0 }}>
          <Paragraph style={[fonts.regular, { color: colors.text, paddingVertical: 0 }]}>{info.title}</Paragraph>
        </DataTable.Title>
        {!isMobile ? (
          <DataTable.Title style={{ position: "absolute", right: spacing.small, paddingVertical: 0 }}>
            <Paragraph style={[fonts.regular, { color: colors.text }]}>{info.value}</Paragraph>
          </DataTable.Title>
        ) : null}
      </DataTable.Header>
    </DataTable>
  );

  const RowDescription = (info: InfoItemData) =>
    isMobile ? (
      <Block pv={spacing.micro}>
        <Paragraph style={[fonts.regular, { flex: 1, color: colors.text }]}>{info.description}</Paragraph>
        {info.label.length && info.value.length ? (
          <Paragraph style={[fonts.regular, { color: colors.placeholder, fontStyle: "italic" }]}>
            {info.label}
            {":  "}
            <Paragraph style={[fonts.regular, { color: colors.text, fontStyle: "normal" }]}>{info.value}</Paragraph>
          </Paragraph>
        ) : (
          <></>
        )}
      </Block>
    ) : (
      <Paragraph style={[fonts.regular, styles.styleDescription]}>{info.description}</Paragraph>
    );

  const RowHeader = () => (
    <DataTable>
      <DataTable.Header style={{ flex: 1, paddingHorizontal: 0, paddingVertical: 0, borderBottomWidth: 1 }}>
        <DataTable.Title style={{ flex: 1 }}>
          <Paragraph style={[fonts.regular, { color: colors.text, fontWeight: "700", paddingVertical: 0 }]}>{item.header?.left}</Paragraph>
        </DataTable.Title>
        {!isMobile ? (
          <DataTable.Title style={{ position: "absolute", right: 0 }}>
            <Paragraph style={[fonts.regular, { color: colors.text, fontWeight: "700" }]}>{item.header?.right}</Paragraph>
          </DataTable.Title>
        ) : null}
      </DataTable.Header>
    </DataTable>
  );

  const renderItem = () => {
    const info = getInfo();
    return (
      <List.Item
        style={{
          minHeight: spacing.galactic,
          backgroundColor: index % 2 === 0 ? colors.surface : colors.select,
          justifyContent: "center",
          padding: 0,
        }}
        title={TitleItem(info)}
        description={RowDescription(info)}
        onPress={() => {
          if (item.data) onPressItem();
        }}
        titleStyle={{
          fontWeight: "700",
          color: colors.text,
        }}
      />
    );
  };

  const renderContent = () => {
    return item?.data ? (
      renderItem()
    ) : item?.header ? (
      <RowHeader />
    ) : item?.alphabet ? (
      <Block>
        <Paragraph style={[fonts.regular, { color: colors.text }]}>{item.alphabet}</Paragraph>
      </Block>
    ) : null;
  };

  return renderContent();
};

export default ItemCardModal;
